import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import QCXFinalFormWizard from '../../../../../shared-components/final-form-wizard/QCXFinalFormWizard';

import AdicaoResumoFormStepWizard from './AdicaoResumoFormStepWizard';
import VisaoGeral from './VisaoGeralFormStepWizard';


const useStyles = makeStyles({
  paper: {
      maxWidth: '80%',
      width: 800,
      '@media (max-width: 900px)': {
          maxWidth: '100%',
          width: '100%',
      },
  },
  title: {
      borderBottom: '2px solid #000000',
  },
});


const RelatorioCalculoFinalFormWizard = ({ isModalOpen, setIsModalOpen, ...restProps }) => {

  const { t } = useTranslation();

  const wizardSteps = ['CAPA', 'ADIÇÕES'];


  return (
    <>
      <QCXFinalFormWizard
        steps={wizardSteps}
        handleChangeValues={() => null}
        isConsult
        isUpdate={false}
        handleSubmit={() => null}
        {...restProps}
      >
      {(formProps) => (
        <VisaoGeral
          key="ficha-relatorio-di"
          {...formProps}
        />
      )}
      {(formProps) => (
        <AdicaoResumoFormStepWizard
          key="ficha-relatorio-adicoes-di"
          {...formProps}
        />
      )}
      </QCXFinalFormWizard>
    </>
  )

}


export default RelatorioCalculoFinalFormWizard;